module.exports = __webpack_public_path__ + "static/desktop/img/hardcover-en.676c6674.png";